import { useQueryClient } from "@tanstack/react-query";
import { Tooltip } from "@trafficsharkdsp/ui";
import { useState } from "react";

import cls from "./Header.module.css";

import { useSessionStore } from "@/entities/session/models/store/useSessionStore";
import { formatMoney } from "@/shared/lib/formatMoney";
import { useCentrifugeSubscription } from "@/shared/lib/useCentrifugeConnect";

export const Balance = () => {
    const { userInfo, accountInfo } = useSessionStore();
    const [wsBalance, setWsBalance] = useState(0);

    const client = useQueryClient();

    const balance = (accountInfo?.balance || 0) + wsBalance;
    const transactionChannel = userInfo.user_id ? `${userInfo.user_id}/transactions` : "";

    useCentrifugeSubscription<{ amount: number; type: "credit" | "debit" }>(
        transactionChannel,
        (newValue) => {
            if (!newValue) return;

            setWsBalance((prev) => {
                return newValue.type === "credit"
                    ? Number(prev) + newValue.amount
                    : Number(prev) - newValue.amount;
            });

            return client.invalidateQueries({ queryKey: ["getApiInternalNotifications"] });
        },
    );
    return (
        <div className={cls["balance-wrapper"]}>
            <span style={{ width: "max-content" }} data-qa="header-balance-value">
                {formatMoney(Number(balance) || 0)}
            </span>

            {balance === 0 && (
                <Tooltip
                    className={cls.tooltip}
                    content="You have reached your account balance limit. Top-up your account balance to continue campaign performance."
                    position="bottom"
                >
                    <span className={cls["balance-limit"]}>i</span>
                </Tooltip>
            )}
        </div>
    );
};
